<template>
  <div>
    <b-modal v-model="showModal"
      title="Datos del registro"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc>
      <div><span><b>Usuario:</b> {{ record.user }}</span></div>
      <div><span><b>Nombre:</b> {{ record.fullname }}</span></div>
      <div><span><b>Tipo de Documento:</b> {{ record.doctype || 'Sin especificar' }}</span></div>
      <div><span><b>N.º de Documento:</b> {{ record.document_number || 'Sin especificar' }}</span></div>
      <div><span><b>Correo Electrónico:</b> {{ record.email }}</span></div>
      <div><span><b>Teléfono:</b> {{ record.phone_number || 'Sin especificar' }}</span></div>
      <div><span><b>Móvil:</b> {{ record.movil_number || 'Sin especificar' }}</span></div>
      <div><span><b>Rol:</b> {{ record.rolename }}</span></div>
      <div><span><b>Estado:</b> {{ statusLabel(record.status) }}</span></div>
      <div><span><b>Correo validado:</b>
        <span :class="{ 'text-danger': !record.email_verified }">{{ verifiedLabel(record) }}</span>
      </span></div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-danger" type="button" @click="close"> <i class="fas fa-times fa-fw"></i>Cerrar</button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal } from 'bootstrap-vue';

export default {
  components: {BModal},
  props: ['record', 'showModal'],
  data() {
    return {
      form: {},
      loading: false,
    }
  },
  methods:{
    statusLabel(status) {
      // El 2 ("pendiente de activar") ya no existe; se conserva por si queda algún
      // registro antiguo sin migrar.
      const labels = {1: 'Activo', 0: 'Bloqueado', 2: 'Pendiente de activar por correo', 3: 'Bloqueado permanentemente'}
      return labels[status] !== undefined ? labels[status] : 'Desconocido'
    },
    verifiedLabel(record) {
      if (!record.email_verified) { return 'No' }
      if (!record.email_verified_at) { return 'Sí' }
      const d = new Date(record.email_verified_at)
      return 'Sí (' + ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear() + ')'
    },
    close(bvModalEvent) {
      this.$emit('update:showModal', false)
    },
    getRecord() {
      this.loading = true
      this.form = {
        id: this.id
      }
    },
  }
}

</script>
